import { MaintenanceModeConfig } from '../../model/maintenance-config/maintenance-mode-config';
var MaintenancePropertyMapper = /** @class */ (function () {
    function MaintenancePropertyMapper() {
    }
    MaintenancePropertyMapper.prototype.mapProperty = function (property) {
        var maintenanceModeConfig = new MaintenanceModeConfig();
        maintenanceModeConfig.enabled = property.enabled;
        maintenanceModeConfig.startDate = this.parse(property.startDate);
        maintenanceModeConfig.endDate = this.parse(property.endDate);
        return maintenanceModeConfig;
    };
    MaintenancePropertyMapper.prototype.parse = function (dateString) {
        if (dateString) {
            dateString = dateString.replace(/\D/g, ' ');
            var dateParts = dateString.split(' ');
            return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5]);
        }
        return null;
    };
    return MaintenancePropertyMapper;
}());
export { MaintenancePropertyMapper };
